import { connect } from 'react-redux';

import {
  addFilterClause,
  removeFilterClause,
  setClausesConcatOperator,
  setFilterClauseOperator,
  setFilterClauseField,
  setFilterClauseValue,
} from '../../../actions/funnel';
import { getMetainf, getProjectZoneId } from '../../../reducers/analyticsApp';
import FilterContainer from '../../../components/filter/FilterContainer';

const mapStateToProps = (state, { event, filter }) => ({
  concatOperator: filter.concatOperator,
  clauses: filter.clauses,
  metainf: getMetainf(state, event),
  zoneId: getProjectZoneId(state),
});

const mapDispatchToProps = (dispatch, { stepIndex }) => ({
  onSetClausesConcatOperator: (value) => dispatch(setClausesConcatOperator(stepIndex, value)),
  onAddFilterClause: () => dispatch(addFilterClause(stepIndex)),
  onRemoveFilterClause: (id) => dispatch(removeFilterClause(stepIndex, id)),
  onSelectFilterClauseField: (id, field, type) =>
    dispatch(setFilterClauseField(stepIndex, id, field, type)),
  onSelectFilterClauseOperator: (id, value, resetClauseValue) =>
    dispatch(setFilterClauseOperator(stepIndex, id, value, resetClauseValue)),
  onFilterClauseValueChange: (id, value) => dispatch(setFilterClauseValue(stepIndex, id, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FilterContainer);
